import { SortOrder } from 'types';
import { ESecondaryDealSortOption } from './types';

export const primaryDealSortVariantsMap = {
  [ESecondaryDealSortOption.PublicationDate]: {
    [SortOrder.ASC]: { sortBy: 'shareSaleBase.createdDate', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'shareSaleBase.createdDate', sortOrder: SortOrder.DESC },
  },

  [ESecondaryDealSortOption.Currency]: {
    [SortOrder.ASC]: { sortBy: 'deal.currencyCode', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'deal.currencyCode', sortOrder: SortOrder.DESC },
  },

  [ESecondaryDealSortOption.Price]: {
    [SortOrder.ASC]: { sortBy: 'shareSaleBase.latestCalculatedPrice', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'shareSaleBase.latestCalculatedPrice', sortOrder: SortOrder.DESC },
  },

  [ESecondaryDealSortOption.PriceDiscount]: {
    [SortOrder.ASC]: { sortBy: 'shareSaleBase.priceMultiplier', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'shareSaleBase.priceMultiplier', sortOrder: SortOrder.DESC },
  },

  [ESecondaryDealSortOption.NominalValue]: {
    [SortOrder.ASC]: { sortBy: 'shareSaleBase.saleAmount', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'shareSaleBase.saleAmount', sortOrder: SortOrder.DESC },
  },

  [ESecondaryDealSortOption.IRR]: {
    [SortOrder.ASC]: { sortBy: 'deal.nominalInterestRate', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'deal.nominalInterestRate', sortOrder: SortOrder.DESC },
  },

  [ESecondaryDealSortOption.Duration]: {
    [SortOrder.ASC]: { sortBy: 'deal.duration', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'deal.duration', sortOrder: SortOrder.DESC },
  },

  [ESecondaryDealSortOption.DefaultRate]: {
    [SortOrder.ASC]: { sortBy: 'risk.defaultRate', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'risk.defaultRate', sortOrder: SortOrder.DESC },
  },

  [ESecondaryDealSortOption.Rating]: {
    [SortOrder.ASC]: { sortBy: 'risk.rating', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'risk.rating', sortOrder: SortOrder.DESC },
  },

  [ESecondaryDealSortOption.ProductType]: {
    [SortOrder.ASC]: { sortBy: 'risk.productType', sortOrder: SortOrder.ASC },
    [SortOrder.DESC]: { sortBy: 'risk.productType', sortOrder: SortOrder.DESC },
  },
};
